import React from "react";
import BusinessIcon from "@mui/icons-material/Business";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import DomainDisabledIcon from "@mui/icons-material/DomainDisabled";
import { designColors } from "services/constants/designTokens";
import { StatCards } from "../StatCards";

// Counts and percentages are both derived from `companies` at render time -
// never pass a precomputed percentage in. Active% + Inactive% must always
// reconcile to Total=100%.
const buildStats = (companies) => {
  const total = companies?.length || 0;
  const active = companies?.filter((c) => c?.status === "Active").length || 0;
  const inactive = total - active;
  const pct = (count) =>
    total === 0 ? "0.0" : ((count / total) * 100).toFixed(1);

  return [
    {
      key: "all",
      label: "Total Companies",
      count: total,
      percentLabel: `${pct(total)}% of all companies`,
      icon: BusinessIcon,
      bg: "#EEF4FF",
      fg: "#1D4ED8",
    },
    {
      key: "active",
      label: "Active Companies",
      count: active,
      percentLabel: `${pct(active)}% of all companies`,
      icon: AddBusinessIcon,
      bg: designColors.tealTint,
      fg: "#16A34A",
    },
    {
      key: "inactive",
      label: "Inactive Companies",
      count: inactive,
      percentLabel: `${pct(inactive)}% of all companies`,
      icon: DomainDisabledIcon,
      bg: "#F1F5F9",
      fg: "#64748B",
    },
  ];
};

export const CompanyStatCards = ({
  companies,
  onCardClick,
  activeFilter,
}) => {
  const stats = buildStats(companies);

  return (
    <StatCards
      stats={stats}
      activeFilter={activeFilter}
      onCardClick={onCardClick}
    />
  );
};
